module.exports = __webpack_public_path__ + "static/media/view_selection_2.18237998.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/WxGraphTool/view_selection_2.png
// module id = 1771
// module chunks = 0